import * as z from "zod";
import { CompensationMethodFilterSchema } from "./compensation-method-filter";
import {
  ProductItemSoldFilterSchema,
  VariantItemSoldFilterSchema,
} from "./item-sold-filter";
import { OrderCreatedDateFilterSchema } from "./order-created-date-filter";
import { ProductNameFilterSchema } from "./product-name-filter";
import { ProductTypeFilterSchema } from "./product-type-filter";
import { ReturnStatusFilterSchema } from "./return-status-filter";
import { ReturnTypeFilterSchema } from "./return-type-filter";
import { SalesChannelFilterSchema } from "./sales-channel-filter";
import { TagsFilterSchema } from "./tags-filter";
import { VendorNameFilterSchema } from "./vendor-name-filter";

export const AnalyticsFilterSchema = z.union([
  OrderCreatedDateFilterSchema,
  ProductItemSoldFilterSchema,
  VariantItemSoldFilterSchema,
  ReturnTypeFilterSchema,
  SalesChannelFilterSchema,
  ReturnStatusFilterSchema,
  CompensationMethodFilterSchema,
  VendorNameFilterSchema,
  ProductNameFilterSchema,
  TagsFilterSchema,
  ProductTypeFilterSchema,
]);

export const ProductAnalyticsFilterSchema = z.union([
  OrderCreatedDateFilterSchema,
  ProductItemSoldFilterSchema,
  ReturnTypeFilterSchema,
  SalesChannelFilterSchema,
  VendorNameFilterSchema,
  ProductNameFilterSchema,
  TagsFilterSchema,
  ProductTypeFilterSchema,
]);

export const VariantAnalyticsFilterSchema = z.union([
  OrderCreatedDateFilterSchema,
  VariantItemSoldFilterSchema,
  ReturnTypeFilterSchema,
  SalesChannelFilterSchema,
]);

export type AnalyticsFilter = z.infer<typeof AnalyticsFilterSchema>;
export type ProductAnalyticsFilter = z.infer<
  typeof ProductAnalyticsFilterSchema
>;
export type VariantAnalyticsFilter = z.infer<
  typeof VariantAnalyticsFilterSchema
>;
